import React, { Component } from 'react'

import { connect } from 'react-redux'
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'

import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { ListDivider } from 'rmwc/List';


import * as api from '../../api/api'
import * as actions from '../../actions'
import StatusMessage from '../../util/StatusMessage'

class OpportunitiesUsersAdmin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      errorMsg: '',
      loadinMessage: 'Loading data. Please wait...',
      data: {
        opportunitiesUsers: [],
        opportunityDetails: ''
      }
    }

  }


  componentDidMount() {
    
    let data = Object.assign({}, this.state.data)

    api.adminOpportunityUsersDisplay(this.props.user.accessToken, this.props.opportunityId).then((result) => {    
      const { status, errors} = result
      
      if (status === 'success') {
        data.opportunitiesUsers = result.data.users
        data.opportunityDetails = result.data.opportunity
        this.setState({data:data, loadinMessage:''})
      }
      else {
        this.setState({ errorMsg: 'Error in Fetching Detail - Error', loadinMessage:'' })  
      }
    })
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details - Exception', loadinMessage:'' })
    })
  }

 
  viewOpportunities =(e) =>{
    e.preventDefault()
    this.props.onViewOpportunities()
  }

  render() {
    
    let dataToDisplay = (
        <tbody>
            {this.state.data.opportunitiesUsers.map(function(oppUser){
              
              if(oppUser.resume == null){
                return(<tr>
                  <td>{oppUser.id}</td>
                  <td>{oppUser.user_name}</td>
                  <td>{oppUser.email}</td>
                  <td>{oppUser.phone}</td>
                  <td>NA</td>
                  <td>{oppUser.first_name}</td>
                  <td>{oppUser.last_name}</td> 
                </tr>)
              }
              else{
               let resumeURL = oppUser.resume
               return(<tr>
                  <td>{oppUser.id}</td>
                  <td>{oppUser.user_name}</td>
                  <td>{oppUser.email}</td>
                  <td>{oppUser.phone}</td>
                  <td><a href={resumeURL} target="_blank"> View Resume</a></td>
                  <td>{oppUser.first_name}</td>
                  <td>{oppUser.last_name}</td>
                </tr>) 
              }


            })}
          </tbody>
      )

    return(<div>
      <Grid>
        <GridCell span="12">
          <Card style={{padding: '25px', background:'#fafafa'}}>
          
            <GridCell span="12">
            <Typography use="headline6">List of Users Applied for Opportunity</Typography>
            <Button onClick={this.viewOpportunities}><ButtonIcon icon="favorite"/>Back</Button>      
            </GridCell>
          </Card>
        </GridCell>
      </Grid>              
      <ListDivider/>
      
      <Grid>
      <GridCell span="6">
        <Typography use="subtitle2"> {this.state.data.opportunityDetails.position} </Typography>
      </GridCell>  
      <GridCell span="3">
        <Typography use="subtitle2"> Apply by: {this.state.data.opportunityDetails.cut_off_date}</Typography>
      </GridCell>
      <GridCell span="3">
        <Typography use="subtitle2"> Status: {this.state.data.opportunityDetails.status} </Typography>
      </GridCell>
      <GridCell span="6">
        <Typography use="body2"> Organization: {this.state.data.opportunityDetails.organization}</Typography>
      </GridCell>
      <GridCell span="3">
        <Typography use="body2"> Location: {this.state.data.opportunityDetails.location} </Typography>
      </GridCell>
      <GridCell span="3">
        <Typography use="body2"> Salary(INR): {this.state.data.opportunityDetails.salary} </Typography>
      </GridCell>
      
      </Grid>

      <ListDivider/>

      <Grid>
        <GridCell span="12">
          <Card style={{padding: '25px', background: '#f7f7f7'}}>
            <StatusMessage error_msg = {this.state.loadinMessage}/>
             <Typography use="headline6" style={{color:'green'}}> {this.state.data.opportunityDetails.position} - {this.state.data.opportunityDetails.location}</Typography>
            <br/>
            <table>
              <th>User Id</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Resume</th>
              <th>First Name</th>
              <th>Last Name</th>
               {dataToDisplay}
            </table>
          </Card>
          <StatusMessage error_msg = {this.state.errorMsg}/>
        </GridCell>
      </Grid>

          
      </div>
    )
}

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(OpportunitiesUsersAdmin);


// WEBPACK FOOTER //
// ./src/views/admin/OpportunitiesUsersAdmin.jsx